import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const pageMeta = {
  '/': {
    title: 'FiberStream | High-Speed FTTH in Southern Leyte by HVGTEC',
    description: 'FiberStream by HVGTEC - Carrier-grade fiber internet in Southern Leyte. Serving Panaon Island, Maasin City with OSPF & VPLS infrastructure. Premium plans from ₱999/month.',
    keywords: 'FiberStream Southern Leyte, HVGTEC ISP, Internet Provider Maasin City, Panaon Island Fiber Internet, FTTH Southern Leyte, Fiber Internet Liloan, Fiber Internet Pintuyan, High-speed internet Philippines'
  },
  '/about': {
    title: 'About HVGTEC | Leading ISP & Network Infrastructure Provider',
    description: 'HVGTEC - 8+ years providing carrier-grade ISP solutions with solar-powered infrastructure. 150+ deployments, 45,000+ subscribers, 99.9% uptime across Southern Leyte.',
    keywords: 'HVGTEC ISP, Southern Leyte Internet Provider, Carrier-grade network Philippines, ISP infrastructure, FTTH provider'
  },
  '/services': {
    title: 'Technical Services | HVGTEC Network Infrastructure Solutions',
    description: 'Comprehensive ISP services: FTTH infrastructure, Headend-in-a-Box, solar Micro POPs, network architecture using Ubiquiti, MikroTik, and Juniper equipment.',
    keywords: 'FTTH infrastructure, ISP technical services, network architecture Philippines, solar-powered ISP, Micro POP deployment'
  },
  '/franchise': {
    title: 'ISP Franchise Opportunities | HVGTEC Micro POP Models',
    description: 'Start your ISP business with HVGTEC Micro POP franchise. ₱241,000 (120 clients) or ₱402,000 (250 clients) packages with 5-7 month ROI. Solar-powered, turnkey deployment.',
    keywords: 'ISP franchise Philippines, Micro POP franchise, Internet business opportunity, HVGTEC franchise, ISP investment Southern Leyte'
  },
  '/resilience': {
    title: 'Solar-Powered Network Infrastructure | Typhoon-Resistant ISP',
    description: 'HVGTEC\'s solar-powered Micro POPs withstand typhoon conditions with 99.9% uptime. Off-grid capable with battery backup for remote Philippine communities.',
    keywords: 'solar-powered ISP, typhoon-resistant network, off-grid internet Philippines, resilient infrastructure, disaster-proof connectivity'
  },
  '/hardware': {
    title: 'Carrier-Grade Equipment | Ubiquiti, MikroTik & Juniper Hardware',
    description: 'HVGTEC uses enterprise equipment from Ubiquiti, MikroTik, and Juniper. Trusted by 150+ ISP deployments with 99.9% network uptime.',
    keywords: 'Ubiquiti ISP, MikroTik carrier-grade, Juniper network equipment, ISP hardware Philippines, carrier-grade routing'
  },
  '/contact': {
    title: 'Contact HVGTEC | Sales & Technical Support',
    description: 'Contact HVGTEC for FiberStream service inquiries, franchise opportunities, or technical support. Available via phone, email, and Messenger.',
    keywords: 'HVGTEC contact, FiberStream support, ISP inquiry Southern Leyte, internet service contact'
  },
  '/apply': {
    title: 'Apply for FiberStream | FTTH Service Application',
    description: 'Apply for FiberStream high-speed fiber internet. Available in Panaon Island and Maasin City. Plans from ₱599/month with no cash-out installation options.',
    keywords: 'apply FiberStream, FTTH application Southern Leyte, fiber internet signup, internet application Maasin'
  },
  '/terms': {
    title: 'Terms & Conditions | HVGTEC Service Agreement',
    description: 'HVGTEC and FiberStream terms of service including lock-in periods, equipment ownership, and Fair Usage Policy.',
    keywords: 'HVGTEC terms, ISP terms and conditions, internet service agreement'
  }
};

const SEO = () => {
  const location = useLocation();

  useEffect(() => {
    const meta = pageMeta[location.pathname] || pageMeta['/'];
    
    // Update title
    document.title = meta.title;
    
    // Update or create meta tags
    updateMetaTag('description', meta.description);
    updateMetaTag('keywords', meta.keywords);
    
    // Open Graph tags for social sharing
    updateMetaTag('og:title', meta.title, 'property');
    updateMetaTag('og:description', meta.description, 'property');
    updateMetaTag('og:type', 'website', 'property');
    updateMetaTag('og:image', 'https://customer-assets.emergentagent.com/job_hvgtec-home/artifacts/8p3d2ihe_HVGTEC%20AI%20Logo.png', 'property');
    
    // Twitter Card tags
    updateMetaTag('twitter:card', 'summary_large_image', 'name');
    updateMetaTag('twitter:title', meta.title, 'name');
    updateMetaTag('twitter:description', meta.description, 'name');
    
  }, [location]);

  const updateMetaTag = (name, content, attribute = 'name') => {
    let element = document.querySelector(`meta[${attribute}="${name}"]`);
    
    if (!element) {
      element = document.createElement('meta');
      element.setAttribute(attribute, name);
      document.head.appendChild(element);
    }
    
    element.setAttribute('content', content);
  };

  return null;
};

export default SEO;
